import { ABaseModel } from '../abstracts/ABaseModel.js';
import {
  IMarketingCampaign,
  IMarketingCampaignSetting,
  IMarketingCampaignPaginationResult,
} from '../interfaces/Marketing.js';
import { PaginationResult } from './List.js';

/**
 * MarketingCampaign
 */
class MarketingCampaign extends ABaseModel implements IMarketingCampaign {
  id: number;
  code: number;
  type: string;
  name: string;
  status: number;
  startDate: string;
  endDate: string;
  description: string;
  settings: Array<MarketingCampaignSetting>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * Marketing campaign settings
 */
class MarketingCampaignSetting extends ABaseModel implements IMarketingCampaignSetting {
  id: number;
  type: number;
  name: string;
  value: string;
  scope: string;
  localizable: boolean;
  storeCode: string;
  localeCode: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * MarketingCampaignPaginationResult
 */
class MarketingCampaignPaginationResult extends PaginationResult implements IMarketingCampaignPaginationResult {
  declare items: Array<MarketingCampaign>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { MarketingCampaign, MarketingCampaignPaginationResult, MarketingCampaignSetting };
